import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import {
    ROLE_EMPLOYEE_CUSTOMER_SERVICE,
    ROLE_CUSTOMER_SERVICE_TEAM_LEAD,
    ROLE_TREATMENT_QUOTATION_ADMIN
} from '../../../security/state/auth/const'
import { userHasAnyOfRoles } from '../../../security/state/auth/selector'

export const selectOwnState = state => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectCustomer = state => {
    return selectOwnState(state).customer
}

export const selectTreatmentQuotation = state => {
    return selectOwnState(state).treatmentQuotation
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}
export const selectIsEditableForUser = state => {
    return selectOwnState(state).isEditableForUser
}
export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}

export const selectIsPreviewModalOpen = state => {
    return selectOwnState(state).previewModalOpen
}

export const selectCustomerId = state => {
    return selectOwnState(state).customerId
}

export const selectFunnelId = state => {
    return selectOwnState(state).funnelId
}

export const selectIsUploadingVideo = state => {
    return selectOwnState(state).uploadingVideo
}

export const selectIsTreatmentQuotationValid = state => {
    const treatmentQuotation = selectTreatmentQuotation(state)
    if (!treatmentQuotation) {
        return false
    }
    return !!(
        treatmentQuotation.brutPrice &&
        treatmentQuotation.physicianCost &&
        treatmentQuotation.treatmentDuration &&
        treatmentQuotation.numberOfAligner &&
        treatmentQuotation.validUntil &&
        treatmentQuotation.treatmentLink
    )
}

export const selectHasUserRoleToEdit = state => {
    const usersThatCanEdit = [
        ROLE_CUSTOMER_SERVICE_TEAM_LEAD,
        ROLE_EMPLOYEE_CUSTOMER_SERVICE,
        ROLE_TREATMENT_QUOTATION_ADMIN
    ]
    return userHasAnyOfRoles(state, usersThatCanEdit)
}

export const selectIsImplantTreatmentQuotationValid = state => {
    const treatmentQuotation = selectTreatmentQuotation(state)
    if (!treatmentQuotation) {
        return false
    }
    return !!(
        treatmentQuotation.brutPrice &&
        (treatmentQuotation.physicianCost || treatmentQuotation.physicianCost === 0) &&
        treatmentQuotation.validUntil
    )
}

export const selectIsTreatmentQuotationReadyForPurchase = state => {
    const treatmentQuotation = selectTreatmentQuotation(state)
    return selectIsTreatmentQuotationValid(state) && treatmentQuotation.approved
}

export const selectIsImplantTreatmentQuotationReadyForPurchase = state => {
    const treatmentQuotation = selectTreatmentQuotation(state)
    return selectIsImplantTreatmentQuotationValid(state) && treatmentQuotation.approved
}



// WEBPACK FOOTER //
// ./src/modules/treatment/state/quotation/selector.js